import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";

const Header = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [menuOpen, setMenuOpen] = useState(false);

  const navItems = [
    { path: "/", label: "Home" },
    { path: "/about-us", label: "About" },
    { path: "/services", label: "Solutions" },
    { path: "/career", label: "Careers" },
    { path: "/contact", label: "Contact" },
  ];

  return (
    <header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 1000,
        backdropFilter: "blur(12px)",
        background: "rgba(255, 255, 255, 0.92)",
        borderBottom: "1px solid rgba(106, 13, 173, 0.12)",
        boxShadow: "0 8px 24px rgba(15, 10, 31, 0.06)",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: isMobile ? "8px 16px" : "10px 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* Logo */}
        <NavLink
          to="/"
          style={{
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
            height: isMobile ? "42px" : "46px",
            overflow: "hidden",
            width: isMobile ? "82px" : "94px",
          }}
        >
          <img
            src="/images/innobyte_logo.png"
            alt="InnoByte Logo"
            style={{
              height: isMobile ? "42px" : "46px",
              width: "auto",
              objectFit: "contain",
              display: "block",
              transform: isMobile ? "scale(1.28)" : "scale(1.35)",
              transformOrigin: "left center",
            }}
          />
        </NavLink>

        {/* Desktop Nav */}
        {!isMobile && (
          <nav style={{ display: "flex", gap: "24px", alignItems: "center" }}>
            {navItems.map((item, index) => (
              <NavLink
                key={index}
                to={item.path}
                style={({ isActive }) => ({
                  color: isActive ? "#6A0DAD" : "#433B57",
                  textDecoration: "none",
                  fontWeight: 500,
                  fontSize: "15px",
                })}
              >
                {item.label}
              </NavLink>
            ))}

            <NavLink
              to="/contact"
              style={{
                background:
                  "linear-gradient(90deg, #6A0DAD, #9D4EDD)",
                padding: "10px 20px",
                borderRadius: "8px",
                color: "#ffffff",
                textDecoration: "none",
                fontWeight: 600,
                fontSize: "14px",
              }}
            >
              Get Consultation
            </NavLink>
          </nav>
        )}

        {/* Mobile Hamburger */}
        {isMobile && (
          <div
            onClick={() => setMenuOpen(!menuOpen)}
            style={{
              width: "28px",
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              gap: "5px",
            }}
          >
            <span style={barStyle(menuOpen, 1)}></span>
            <span style={barStyle(menuOpen, 2)}></span>
            <span style={barStyle(menuOpen, 3)}></span>
          </div>
        )}
      </div>

      {/* Mobile Menu */}
      {isMobile && menuOpen && (
        <div
          style={{
            background: "#ffffff",
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "18px",
            borderTop: "1px solid rgba(106, 13, 173, 0.12)",
            boxShadow: "0 12px 24px rgba(15, 10, 31, 0.05)",
          }}
        >
          {navItems.map((item, index) => (
            <NavLink
              key={index}
              to={item.path}
              onClick={() => setMenuOpen(false)}
              style={({ isActive }) => ({
                color: isActive ? "#6A0DAD" : "#433B57",
                textDecoration: "none",
                fontSize: "16px",
                fontWeight: 500,
              })}
            >
              {item.label}
            </NavLink>
          ))}

          <NavLink
            to="/contact"
            onClick={() => setMenuOpen(false)}
            style={{
              marginTop: "10px",
              background:
                "linear-gradient(90deg, #6A0DAD, #9D4EDD)",
              padding: "12px",
              borderRadius: "8px",
              color: "#ffffff",
              textAlign: "center",
              textDecoration: "none",
              fontWeight: 600,
            }}
          >
            Get Consultation
          </NavLink>
        </div>
      )}
    </header>
  );
};

const barStyle = (menuOpen, index) => ({
  height: "3px",
  background: "#2D2640",
  borderRadius: "2px",
  transition: "0.3s",
  transform:
    menuOpen && index === 1
      ? "rotate(45deg) translateY(8px)"
      : menuOpen && index === 2
      ? "scaleX(0)"
      : menuOpen && index === 3
      ? "rotate(-45deg) translateY(-8px)"
      : "none",
});

export default Header;
